import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const complianceHoldExtendAtom = createMutationAtomFactory(
  'trade.complianceHoldExtend',
  (params: {
    id: string;
    holdEnd: string;
    holdDays: number;
    notes: string;
  }) => ({
    tradeComplianceHoldExtend: {
      __args: {
        id: params.id,
        input: {
          holdEnd: params.holdEnd,
          holdDays: params.holdDays,
          notes: params.notes,
        },
      },
      id: true,
      status: true,
      holdEnd: true,
      holdDays: true,
    },
  }),
);
